import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, EASE } from "./motion";
import { ChevronDown } from "lucide-react";

const flow = [
  { label: "The restaurant" },
  { label: "Verlo Node" },
  { label: "The cloud" },
  { label: "Back office" },
  { label: "Reports" },
  { label: "Verlo intelligence" },
];

export default function Node() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section id="node" data-testid="chapter-node" className="border-t border-verlo/10">
      {/* photography-led hero */}
      <div ref={ref} className="relative overflow-hidden h-[85vh] min-h-[560px]">
        <motion.img
          src="https://images.pexels.com/photos/5858030/pexels-photo-5858030.jpeg"
          alt="Warm UK gastropub interior at service"
          style={{ y }}
          className="absolute inset-0 w-full h-[114%] object-cover -top-[7%]"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-verlo/55" />
        <div className="relative h-full mx-auto max-w-[1400px] px-6 md:px-12 flex flex-col justify-end pb-16 md:pb-24">
          <Reveal>
            <div className="flex items-baseline gap-4 mb-6">
              <span className="font-display text-brass text-lg">V</span>
              <span className="text-xs md:text-sm tracking-[0.2em] uppercase font-medium text-paper/80">
                Node
              </span>
            </div>
            <h2 className="font-display font-light text-5xl md:text-7xl tracking-tight leading-[1.1] text-paper mb-6">
              Hardware you would leave on show.
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-paper/85 max-w-xl">
              One considered object for the pass or the bar. It boots in seconds, runs cool,
              and keeps taking orders when the internet does not.
            </p>
          </Reveal>
        </div>
      </div>

      {/* architecture flow */}
      <div className="px-6 md:px-12 py-24 md:py-36 bg-sand">
        <div className="mx-auto max-w-[1000px]">
          <Reveal>
            <p className="text-xs tracking-[0.2em] uppercase text-brass mb-10 text-center">
              How it all connects
            </p>
          </Reveal>
          <div className="flex flex-col items-center">
            {flow.map((step, i) => (
              <div key={step.label} className="w-full flex flex-col items-center">
                <Reveal>
                  <div className="w-full max-w-md text-center bg-paper border border-verlo/10 rounded-lg shadow-soft px-6 py-5">
                    <p className="font-display text-xl md:text-2xl text-verlo">{step.label}</p>
                  </div>
                </Reveal>
                {i < flow.length - 1 && (
                  <motion.div
                    initial={{ opacity: 0, y: -6 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, ease: EASE }}
                    className="py-3 text-brass"
                  >
                    <ChevronDown size={22} />
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
